// SR (Glicko rating) → tier. Tune thresholds freely.
export const TIERS = [
  {
    name: "Elite",
    min: 2500,
    text: "text-rose-400",
    chip: "text-rose-300 bg-rose-500/10 border-rose-500/40",
  },
  {
    name: "Master",
    min: 2200,
    text: "text-fuchsia-400",
    chip: "text-fuchsia-300 bg-fuchsia-500/10 border-fuchsia-500/40",
  },
  {
    name: "Diamond",
    min: 1950,
    text: "text-sky-400",
    chip: "text-sky-300 bg-sky-500/10 border-sky-500/40",
  },
  {
    name: "Platinum",
    min: 1750,
    text: "text-cyan-300",
    chip: "text-cyan-200 bg-cyan-500/10 border-cyan-500/40",
  },
  {
    name: "Gold",
    min: 1550,
    text: "text-yellow-400",
    chip: "text-yellow-300 bg-yellow-500/10 border-yellow-500/40",
  },
  {
    name: "Silver",
    min: 1400,
    text: "text-slate-300",
    chip: "text-slate-200 bg-slate-400/10 border-slate-400/40",
  },
  {
    name: "Bronze",
    min: 0,
    text: "text-amber-600",
    chip: "text-amber-500 bg-amber-600/10 border-amber-600/40",
  },
];

export function getTier(sr) {
  if (sr == null) return null;
  return TIERS.find((t) => sr >= t.min);
}
